<template>
  <div class="app-logo" :class="{ 'app-logo--psy': isPsyfeature && !iconOnly, 'app-logo--icon': iconOnly }">
    <img :src="src" :alt="appName + ' Logo'" class="logo-img" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

/**
 * `iconOnly` was declared here long before anything rendered it. It now
 * switches to the tenant's compact mark (theme.icon.url, uploaded in
 * Settings), which falls back to the full logo when none is set — so a
 * collapsed rail shows the symbol where one exists and the lockup,
 * scaled down, where it does not.
 */
const props = defineProps({
  iconOnly: {
    type: Boolean,
    default: false
  }
})

const { logoUrl, iconUrl, appName, tenant } = useTenantTheme()

const src = computed(() => (props.iconOnly ? iconUrl.value : logoUrl.value))
const isPsyfeature = computed(() => tenant.value?.slug === 'psyfeature')
</script>

<style scoped>
.app-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-heading, sans-serif);
  font-weight: 800;
  letter-spacing: -0.05em;
  user-select: none;
}

.logo-img {
  height: 52px;
  object-fit: contain;
  filter: brightness(1.2);
  transition: height 0.2s ease;
}

.app-logo--psy .logo-img {
  height: 64px;
}

/* Icon mode: a square slot for a narrow rail. `object-fit: contain`
   means a tenant with no icon still fits — their wide lockup is scaled
   down rather than cropped. */
.app-logo--icon .logo-img {
  height: 32px;
  width: 32px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .logo-img {
    height: 42px;
  }
  .app-logo--psy .logo-img {
    height: 52px;
  }
}

.logo-text {
  font-size: 1.5rem;
  line-height: 1;
  display: flex;
}

.text-diz {
  color: var(--text-main);
}

.text-tree {
  color: var(--primary);
}
</style>
